import { RepositoryFactory } from '../repositories/RepositoryFactory';


const basicRepository = RepositoryFactory.get('basic')

const basic = {
    namespaced: false,
    state: {
        error: null
    },
    mutations: {
        error (state, status) {
            state.error = status
        }
    },
    actions: {
        getAktionen ({ commit }) {
            /*  commit('start_loading') */
            return basicRepository.getAktionen()
                .then(resp => {
                    commit('success')
                    return resp;
                })
                .catch(err => {
                    commit('error')
                    return err;
                }).finally(() => { /* commit('stop_loading') */ });
        },
        getBrief ({ commit }, id) {
            /*  commit('start_loading') */
            return basicRepository.getBrief(id)
                .then(resp => {
                    commit('success')
                    return resp;
                })
                .catch(err => {
                    commit('error')
                    return err;
                }).finally(() => { /* commit('stop_loading') */ });
        },

        updateCronJob ({ commit }, payload) {
            return basicRepository.updateCronJob(payload)
                .then(resp => {
                    commit('success')
                    return resp;
                })
                .catch(err => {
                    commit('error')
                    return err;
                }).finally(() => { });
        },

        updateTexte ({ commit }, payload) {
            return basicRepository.updateTexte(payload)
                .then(resp => {
                    commit('success')
                    return resp;
                })
                .catch(err => {
                    commit('error')
                    return err;
                }).finally(() => { });
        },
        updateBrief ({ commit }, payload) {
            return basicRepository.updateBrief(payload)
                .then(resp => {
                    commit('success')
                    return resp;
                })
                .catch(err => {
                    commit('error')
                    return err;
                }).finally(() => { });
        },
        insertBrief ({ commit }, payload) {
            return basicRepository.insertBrief(payload)
                .then(resp => {
                    commit('success')
                    return resp;
                })
                .catch(err => {
                    commit('error')
                    return err;
                }).finally(() => { });
        },

        checkLader ({ commit }, payload) {
            return basicRepository.checkLader(payload)
                .then(resp => {
                    commit('success')
                    return resp;
                })
                .catch(err => {
                    commit('error')
                    return err;
                }).finally(() => { });
        },
        searchSepp ({ commit }, payload) {
            return basicRepository.searchSepp(payload)
                .then(resp => {
                    commit('success')
                    return resp;
                })
                .catch(err => {
                    commit('error')
                    return err;
                }).finally(() => { });
        },
        getTexte ({ commit }, payload) {
            return basicRepository.getTexte(payload)
                .then(resp => {
                    commit('success')
                    return resp;
                })
                .catch(err => {
                    commit('error')
                    return err;
                }).finally(() => { });
        },
        saveNewAktion ({ commit }, payload) {
            return basicRepository.saveNewAktion(payload)
                .then(resp => {
                    commit('success')
                    return resp;
                })
                .catch(err => {
                    commit('error')
                    return err;
                }).finally(() => { });
        },
        neueAktionSenden ({ commit }, payload) {
            return basicRepository.neueAktionSenden(payload)
                .then(resp => {
                    commit('success')
                    return resp;
                })
                .catch(err => {
                    commit('error')
                    return err;
                }).finally(() => { });
        },

        saveNewtext ({ commit }, payload) {
            return basicRepository.saveNewtext(payload)
                .then(resp => {
                    commit('success')
                    return resp;
                })
                .catch(err => {
                    commit('error')
                    return err;
                }).finally(() => { });
        },

        getVorlagenParsed ({ commit }, { art, aid, abs_id, user_id }) {
            commit('start_loading')
            return basicRepository.getVorlagenParsed(art, aid, abs_id, user_id)
                .then(resp => {
                    commit('success')
                    commit('stop_loading')
                    return resp;

                })
                .catch(err => {
                    commit('error')
                    return err;
                }).finally(() => { });
        },
        getVorlagenParsedId ({ commit }, { id, aid, abs_id }) {
            commit('start_loading')
            return basicRepository.getVorlagenParsedId(id, aid, abs_id)
                .then(resp => {
                    commit('success')
                    commit('stop_loading')
                    return resp;
                })
                .catch(err => {
                    commit('error')
                    return err;
                }).finally(() => { });
        },
        getStats ({ commit }) {
            /* console.log('store', tarif_id) */
            return basicRepository.getStats()
                .then(resp => {
                    commit('success')
                    return resp;
                })
                .catch(err => {
                    commit('error')
                    return err;
                }).finally(() => { });
        },
        getChecks ({ commit }) {
            /* console.log('store', tarif_id) */
            return basicRepository.getChecks()
                .then(resp => {
                    commit('success')
                    return resp;
                })
                .catch(err => {
                    commit('error')
                    return err;
                }).finally(() => { });
        },
        getCrons ({ commit }) {
            /* console.log('store', tarif_id) */
            return basicRepository.getCrons()
                .then(resp => {
                    commit('success')
                    return resp;
                })
                .catch(err => {
                    commit('error')
                    return err;
                }).finally(() => { });
        },
        getRefs ({ commit }) {
            /* console.log('store', tarif_id) */
            return basicRepository.getRefs()
                .then(resp => {
                    commit('success')
                    return resp;
                })
                .catch(err => {
                    commit('error')
                    return err;
                }).finally(() => { });
        },
        getChatStatus ({ commit }) {
            /* console.log('store', tarif_id) */
            return basicRepository.getChatStatus()
                .then(resp => {
                    commit('success')
                    return resp;
                })
                .catch(err => {
                    commit('error')
                    return err;
                }).finally(() => { });
        },
        openCloseChat ({ commit }, type) {
            /* console.log('store', tarif_id) */
            return basicRepository.openCloseChat(type)
                .then(resp => {
                    commit('success')
                    return resp;
                })
                .catch(err => {
                    commit('error')
                    return err;
                }).finally(() => { });
        },
        getVorlagen ({ commit }, art) {
            /* console.log('store', tarif_id) */
            return basicRepository.getVorlagen(art)
                .then(resp => {
                    commit('success')
                    return resp;
                })
                .catch(err => {
                    commit('error')
                    return err;
                }).finally(() => { });
        },


    },
    getters: {

    }

}

export default basic